let current = 0;
let alreadySignedUp = false;
let businessId;

const steps = document.querySelectorAll('.form-step');
const form = document.getElementById('event-form');
const button = document.getElementById('nextBtn');

const validateMap = {
  0: ['eventSelect']
};

document.addEventListener('DOMContentLoaded', () => {
  getBusinessId();
  updateStep();
  form.addEventListener('submit', handleFormSubmit);
});

/**
 * Prefill all known fields from query params.
 */
function getBusinessId() {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get('businessId');
  businessId = value;

  if (value) {
    getZohoDetails(decodeURIComponent(value))
      .then(contact => {
        if (contact.already_signed_up) {
          window.location.replace('/');
          return;
        }

        button.disabled = false;
        populateDetails(contact);
      })
      .catch(err => {
        console.error('Zoho details fetch failed:', err);
        if (!(window.Shopify && window.Shopify.designMode)) window.location.replace('/');
      });

  } else if (!(window.Shopify && window.Shopify.designMode)) {
    window.location.replace('/');
  }
}

/**
 * Run a webhook to Make.com and return the zoho details.
 */
async function getZohoDetails(contactId) {
  const res = await fetch('https://hook.eu2.make.com/negbsgvfhtn8x9uriwx6y1t3nv4tqkvd', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: contactId })
  });

  if (!res.ok) throw new Error(`Make error ${res.status}`);

  const data = await res.json();
  const contact = Array.isArray(data?.data) ? data.data[0] : null;

  if (!contact) throw new Error('Contact not found');

  const stage = (contact.stage || '').trim().toLowerCase();
  const alreadySignedUpStages = [
    'training booked',
    'training attended',
    'partner (first order purchased)'
  ];

  alreadySignedUp = alreadySignedUpStages.includes(stage);

  return {
    ...contact,
    already_signed_up: alreadySignedUp
  };
}

/**
 * Populate the form details from Zoho.
 */
function populateDetails(contact) {
  let nameField = document.querySelector('#namePrefill');
  let companyField = document.querySelector('#businessPrefill');
  
  if (nameField) nameField.textContent = contact.name ?? '';
  if (companyField) companyField.textContent = contact.company ?? '';
  checkLocations(contact);
  populateAttendees(contact.staff, contact.company);
}

/**
 * Location checker - If locations are sold out, disable the option.
 */
function checkLocations(contact, capacity = 100) {
  const selector = document.querySelector('#eventSelect');
  if (!selector) return;

  selector.disabled = false;

  selector.querySelectorAll('option').forEach(o => {
    o.disabled = false;
    o.textContent = o.textContent.replace(/\s*\(Sold Out\)$/i, '');
  });

  const staffAmount = Array.isArray(contact?.staff) ? contact.staff.length : 0;

  const mapping = {
    location_a: 'Location A',
    location_b: 'Location B',
    location_c: 'Location C',
    location_d: 'Location D',
    location_e: 'Location E'
  };

  Object.entries(mapping).forEach(([locationKey, optionValue]) => {
    const base = Number(contact?.[locationKey]) || 0; // avoid NaN
    const projected = base + staffAmount;

    const option = selector.querySelector(`option[value="${optionValue}"]`);
    if (!option) return;

    if (projected >= capacity) {
      option.disabled = true;
      option.textContent += ' (Sold Out)';
    }
  });
}

/**
 * Populate staff.
 */
function populateAttendees(staffMembers = [], company) {
  const wrap = document.querySelector('#event-form-staff');
  if (!wrap) return;

  if (!Array.isArray(staffMembers) || staffMembers.length === 0) {
    wrap.innerHTML = '<p class="error-msg center">No staff on file.</p>';
    return;
  }

  // Sort so "Main Contact" comes first
  staffMembers.sort((a, b) => {
    const aMain = String(a.Role ?? a.role ?? '').toLowerCase() === 'main contact';
    const bMain = String(b.Role ?? b.role ?? '').toLowerCase() === 'main contact';
    return aMain === bMain ? 0 : aMain ? -1 : 1;
  });

  wrap.innerHTML = staffMembers.map((raw, i) => {
    const staff = {
      id: raw.id ?? raw.Id ?? '',
      name: raw.Full_Name ?? raw.full_name ?? raw.FullName ?? '',
      email: raw.Email ?? raw.email ?? '',
      phone: raw.Phone ?? raw.phone ?? '',
      role: raw.Role ?? raw.role ?? ''
    };

    const dietaryId = `staff-${i}-dietary`;
    const accessId  = `staff-${i}-access`;

    return `
      <section class="staff-card is-off" data-i="${i}" tabindex="0" aria-pressed="false">
        <div class="staff-head">
          <label class="checkbox">
            <input type="checkbox" name="checkbox_${i}">
          </label>
          <p class="h6">${h(staff.name)}</p>
          <p class="caption">${h(staff.email)}</p>
        </div>

        <div class="staff-extra-container">
          <div class="staff-extra">
            <input
              type="text"
              class="field__input"
              id="${dietaryId}"
              name="staff[${i}][dietary]"
              maxlength="150"
              placeholder="${formLabels.dietary}"
            >
          </div>

          <div class="staff-extra">
            <input
              type="text"
              class="field__input"
              id="${accessId}"
              name="staff[${i}][accessibility]"
              maxlength="150"
              placeholder="${formLabels.accessibility}"
            >
          </div>
        </div>

        <!-- Hidden core fields -->
        <input type="hidden" name="staff[${i}][id]"        value="${h(staff.id)}">
        <input type="hidden" name="staff[${i}][company]"   value="${h(company)}">
        <input type="hidden" name="staff[${i}][full_name]" value="${h(staff.name)}">
        <input type="hidden" name="staff[${i}][email]"     value="${h(staff.email)}">
        <input type="hidden" name="staff[${i}][phone]"     value="${h(staff.phone)}">
        <input type="hidden" name="staff[${i}][role]"      value="${h(staff.role)}">
      </section>
    `;
  }).join('');

  // Append count element
  const countEl = document.createElement('p');
  countEl.className = 'staff-count caption';
  wrap.appendChild(countEl);

  const updateCount = () => {
    const count = wrap.querySelectorAll('.staff-card.is-on').length;
    countEl.textContent = `${count} of ${staffMembers.length} staff members selected.`;
  };

  // toggle helper
  const setOn = (card, on) => {
    card.classList.toggle('is-on', on);
    card.classList.toggle('is-off', !on);
    card.setAttribute('aria-pressed', on ? 'true' : 'false');
    card.querySelectorAll('input').forEach(el => {
      if (el.type === 'text') el.disabled = !on;
      if (el.type === 'checkbox') {
        el.disabled = !on;
        el.checked = on;
      }
      if (el.type === 'hidden') el.disabled = !on;
    });
    updateCount();
  };

  // delegated click + keyboard
  const toggleFrom = (target) => {
    const card = target.closest('.staff-card');
    if (!card) return;
    setOn(card, !card.classList.contains('is-on'));
    if (getSelectedStaffCount() > 0) clearStaffError();
  };

  wrap.addEventListener('click', e => {
    // Don’t toggle if clicking inside a text input or label
    if (e.target.closest('input[type="text"],label')) return;
    toggleFrom(e.target);
  });

  wrap.addEventListener('keydown', e => {
    if (e.target.closest('input[type="text"]')) return; // let user type
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleFrom(e.target);
    }
  });
}


/**
 * HTML Escape.
 */
function h(v) {
  return String(v ?? '').replace(/[&<>"']/g, s => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[s]));
}

/**
 * Get selected staff count.
 */
function getSelectedStaffCount() {
  return document.querySelectorAll('#event-form-staff .staff-card.is-on').length;
}

/**
 * Show staff error when no staff selected.
 */
function showStaffError() {
  let err = document.getElementById('staffError');
  if (!err) {
    err = document.createElement('div');
    err.id = 'staffError';
    err.classList.add('error-msg');
    err.style.color = '#ef3427';
    err.style.marginTop = '1rem';
    const wrap = document.querySelector('#event-form-staff');
    wrap?.after(err);
  }
  err.textContent = formLabels.errorStaff;
  err.style.display = 'block';
}

/**
 * Clear staff error.
 */
function clearStaffError() {
  const err = document.getElementById('staffError');
  if (err) err.style.display = 'none';
}

/**
 * Displays validation error on a given field.
 */
function showError(id, message) {
  const el = document.getElementById(id);
  const error = document.getElementById(id + 'Error');
  if (el) el.style.borderColor = '#ef3427';
  if (error && message) {
    error.style.display = 'block';
    error.textContent = message;
  }
  el?.addEventListener('input', () => clearError(id), { once: true });
}

/**
 * Clears error state from a given field.
 */
function clearError(id) {
  const el = document.getElementById(id);
  const error = document.getElementById(id + 'Error');
  if (el) el.style.border = '';
  if (error) {
    error.style.display = 'none';
    error.textContent = '';
  }
}

/**
 * Validates a list of input fields and applies contextual rules.
 */
function validateSimple(ids) {
  let valid = true;

  ids.forEach(id => {
    clearError(id);
    const el = document.getElementById(id);
    if (!el || el.offsetParent === null) return;

    const val = el.value.trim();
    if (!val) {
      showError(id, formLabels.errorField);
      valid = false;
    }
  });
  return valid;
}

/**
 * Navigates to the previous form step.
 */
function prevStep() {
  if (current > 0) {
    current--;
    updateStep();
  }
}

/**
 * Validates current step and moves to the next if valid.
 */
function nextStep() {
  if (validateMap[current] && !validateSimple(validateMap[current])) return;

  if (current === 1 && getSelectedStaffCount() === 0) {
    showStaffError();
    window.scrollTo({ top: 95, behavior: 'smooth' });
    return;
  }

  current = Math.min(current + 1, steps.length - 1);
  updateStep();
}

/**
 * Updates the current form step display.
 */
function updateStep() {
  steps.forEach((s, i) => s.classList.toggle('active', i === current));
  window.scrollTo({ top: 95, behavior: 'smooth' });
}

/**
 * Jumps to a specific step index.
 */
function goToStep(index) {
  current = index;
  updateStep();
}

/**
 * Handles final form submission: validation, cleanup, and sending form data via fetch.
 */
function handleFormSubmit(event) {
  event.preventDefault();

  const submitBtn = document.querySelector('#event-form-submit');
  const formContainer = document.querySelector('.pro-form');
  const formData = new FormData(form);
  const allValid = Object.values(validateMap).every(fields => validateSimple(fields));
  const eventSelect = document.querySelector('#eventSelect');

  if (eventSelect) {
    const selectedOption = eventSelect.options[eventSelect.selectedIndex];
    formData.set('eventSelectText', selectedOption.text);
  }

  if (getSelectedStaffCount() === 0) {
    showStaffError();
    window.scrollTo({ top: 95, behavior: 'smooth' });
    return;
  }

  if (!allValid) {
    window.scrollTo({ top: 95, behavior: 'smooth' });
    return;
  }

  if (businessId) {
    formData.set('businessId', businessId);
  }

  formData.set('alreadySignedUp', alreadySignedUp ? 'true' : 'false');

  submitBtn?.classList.add('loading');
  submitBtn.disabled = true;

  fetch('https://hook.eu2.make.com/9nt8nn1et3ivfnjnm0glqzpmxt56kd78', {
    method: 'POST',
    body: formData,
    cache: 'no-cache'
  })
    .then(res => res.text())
    .then(() => {
      submitBtn?.classList.remove('loading');
      formContainer.style.display = 'none';
      document.getElementById('thankYouPage').style.display = 'flex';
      window.scrollTo({ top: 0, behavior: 'smooth' });
      form.reset();
      current = 0;
      updateStep();
    })
    .catch(error => {
      alert('An error occurred: ' + error.message);
      submitBtn?.classList.remove('loading');
      if (submitBtn) submitBtn.disabled = false;
    });
}